module.exports = __webpack_public_path__ + "static/media/cor.59e04756.jpeg";